<div class="modal fade" id="modal-message" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered maxw-640">
      <div class="modal-content maxh-660">
        <div class="modal-header align-items-center pl-4 pr-2 py-2">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&times;</button>
          <div class="d-flex align-items-center">
            <ul class="nav btn-title-tab-group">
              <li class="nav-item" (click)="historyMode = false">
                <a class="nav-link btn-tab active" id="#message-options-tab" data-bs-toggle="tab" href="#message-options" role="tab" aria-selected="true">
                  {{ 'communication.createMessage' | translate | uppercase }}
                </a>
              </li>
              <li class="nav-item" (click)="getHistory(); historyMode = true;">
                <a class="nav-link btn-tab" id="#message-history-tab" data-bs-toggle="tab" href="#message-history" role="tab" aria-selected="false">
                  {{ 'communication.history' | translate | uppercase }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-body p-0">
          <div class="tab-content">
            <div class="tab-pane fade active show" id="message-options" role="tabpanel">
              <div class="modal-list-item">
                <div class="modal-list-item-header">{{ 'communication.messageOptions' | translate | uppercase }}</div>
                <div class="row row-sm">
                  <div class="col-12 col-sm-3">
  
                    <div class="dropdown ihost-dropdown ihost-replace-val">
                      <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                          {{channel?.value}}                    
                      </a>
                      <div class="dropdown-menu w-100">
                        <a *ngFor="let comChannel of supportedChannels" class="dropdown-item" (click)="selectChannel(comChannel)">{{comChannel.value}}</a>                        
                      </div>
                    </div>                  
                  </div>
                  <div class="col-12 col-sm-6">
                    <div id="message-type-dropdown" class="dropdown ihost-dropdown ihost-replace-val">
                      <a class="dropdown-toggle selected-message" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        {{uiLang == "el" ? message?.name_el : message?.name_en }}
                      </a>
                      <div class="dropdown-menu w-100">
                        <a class="dropdown-item message-list-item" *ngFor="let msg of messages" (click)="selectMessage(msg)">{{uiLang == "el" ? msg.name_el : msg.name_en}}</a>                        
                      </div>
                    </div>                
                  </div>
                  <div class="col-12 col-sm-3">
                    <div class="dropdown ihost-dropdown ihost-replace-val">
                      <a class="dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <span *ngIf="lang == 'el'">{{ 'communication.greek' | translate }}</span>
                        <span *ngIf="lang != 'el'">{{ 'communication.english' | translate }}</span>
                      </a>
                      <div class="dropdown-menu w-100">
                        <a class="dropdown-item" (click)="selectLang('el')">{{ 'communication.greek' | translate }}</a>
                        <a class="dropdown-item" (click)="selectLang('en')">{{ 'communication.english' | translate }}</a>
                      </div>
                    </div>                  
                  </div>
                </div>
              </div>

              <!-- Source / Customer -->
              <div id="cc-list-item" class="modal-list-item" *ngIf="hasSourceMail || hasSourcePhone">
                <div class="modal-list-item-header">{{ 'communication.sendTo' | translate | uppercase }}</div>
                <div class="custom-control custom-radio custom-control-inline"  (click)="toggleSendToSource(false)">
                  <input type="radio" id="send-customer" name="send-target" class="custom-control-input" value="send-customer" [checked]="!sendToSource">
                  <label class="custom-control-label" for="send-customer">{{ 'communication.customer' | translate }}</label>
                </div>
                <div class="d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline" (click)="toggleSendToSource(true)">
                    <input type="radio" id="send-source" name="send-target" class="custom-control-input" value="send-source" [checked]="sendToSource">
                    <label class="custom-control-label" for="send-source" >{{ 'communication.source' | translate }}</label>
                  </div>                  
                </div>
              </div>

              <!-- Credit Card Extra -->
              <div id="cc-list-item" class="modal-list-item" *ngIf="message?.messageId == '16'">
                <div class="modal-list-item-header">{{ 'communication.creditCardChargeDetails' | translate | uppercase }}</div>
                <div class="custom-control custom-radio custom-control-inline"  (click)="creditCardModeManual = false">
                  <input type="radio" id="credit-default" name="credit-charge" class="custom-control-input" value="credit-default" [checked]="!creditCardModeManual">
                  <label class="custom-control-label" for="credit-default">{{ 'communication.default' | translate }}</label>
                </div>
                <div class="d-inline-block">
                  <div class="custom-control custom-radio custom-control-inline" (click)="creditCardModeManual = true">
                    <input type="radio" id="credit-manual" name="credit-charge" class="custom-control-input" value="credit-manual" [checked]="creditCardModeManual">
                    <label class="custom-control-label" for="credit-manual" >{{ 'communication.manual' | translate }}</label>
                  </div>
                  <input *ngIf="creditCardModeManual" id="charge-amount" type="number" step="1" min="1" [(ngModel)]="creditCardCharge" 
                          class="ihost-control d-inline-block mb-2" placeholder="{{ 'communication.amount' | translate }}" style="width:160px">
                </div>
              </div>
              <!-- Details -->
              <div class="modal-list-item border-bottom-0">
                <div class="modal-list-item-header">{{ 'communication.details' | translate | uppercase }}</div>
                <div class="row row-sm">                  
                  <div class="col-12 col-sm-6">
                    <div class="ihost-input-group">
                      <label for="message-email" class="ihost-input-group-text mb-0">{{ 'communication.recipient' | translate }}</label>
                      <input id="message-email" type="email" class="ihost-control w-100" [(ngModel)]="recepient">
                    </div>
                  </div>
                  <div class="col-12 col-sm-6" *ngIf="channel?.value == 'SMS'">
                    <div class="ihost-input-group">
                      <label for="message-name" class="ihost-input-group-text mb-0">{{ 'communication.sender' | translate }}</label>
                      <input type="text" id="message-name" class="ihost-control w-100" [(ngModel)]="sender">
                    </div>
                  </div>

                  <div class="col-12" *ngIf="channel?.value == 'EMAIL'">
                    <div class="ihost-input-group">
                      <label for="message-subject" class="ihost-input-group-text mb-0">{{ 'communication.subject' | translate }}</label><br/>
                      {{header}}
                    </div>
                  </div>
                  <div class="col-12" *ngIf="channel?.value == 'SMS'">
                    <textarea style="height: 150px" class="ihost-control" [(ngModel)]="body"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="message-history" role="tabpanel">             
                <div class="list-item-sm" *ngFor="let item of historyItems; let i = index">
                  <a class="row-link" data-bs-toggle="collapse" [href]="'#collapse-' + i"></a>
                  <div class="list-item-sm-content">
                    <p class="text-sm mb-1">
                      <span *ngIf="item.recipient.indexOf('@') > -1" class="color-square bg-lime">EMAIL</span>
                      <span *ngIf="item.recipient.indexOf('@') == -1" class="color-square bg-teal">SMS</span>
                      {{item.recipient.indexOf('@') > -1 ? item.header.substr(0, 50) : item.body.substr(0, 50)}}
                      <span *ngIf="item.recipient.indexOf('@') == -1 && item.body.length > 50">...</span>
                      <span *ngIf="item.recipient.indexOf('@') > -1 && item.header.length > 50">...</span>
                    </p>
                    <div [attr.id]="'collapse-' + i" class="collapse">
                      <div class="text-sm">
                        <p class="history-detail"><strong>{{ 'communication.from' | translate }}:</strong> {{item.sender}}</p>
                        <p class="history-detail"><strong>{{ 'communication.to' | translate }}:</strong> {{item.recipient}}</p>
                        <p class="history-detail"><strong>{{ 'communication.statusChangedAt' | translate }}:</strong> {{item.currentStatusChangedAt | amDateFormat:'DD-MM-yyyy, HH:mm'}}</p>
                        <p class="history-detail"><strong>{{ 'communication.toBeSentAt' | translate }}:</strong> {{item.toBeSentAt | amDateFormat:'DD-MM-yyyy, HH:mm'}}</p>                        
                        <!-- <p *ngIf="item.recipient.indexOf('@') > -1"><strong>Subject:</strong> {{item.header}}</p> -->
                        <p class="history-detail" *ngIf="item.recipient.indexOf('@') == -1"><strong>{{ 'communication.message' | translate }}:</strong> {{item.body}}</p>                         
                        <p class="history-detail" *ngIf="item.recipient.indexOf('@') > -1"><strong>{{ 'communication.subject' | translate }}:</strong> {{item.header}}</p>                         
                      </div>
                    </div>
                  </div>
                  <div class="list-item-status ml-auto text-nowrap pl-3">
                    <i *ngIf="item.currentStatus == 'delivered'" class="ihost-icon-checkmark ml-1"></i>
                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'delivered'">{{ 'communication.delivered' | translate }}</i>
                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'sent'">{{ 'communication.sent' | translate }}</i>                    
                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'sending'">{{ 'communication.senting' | translate }}</i>                    
                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'queued'">{{ 'communication.queued' | translate }}</i>
                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'undelivered'">{{ 'communication.undelivered' | translate }}</i>
                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'failed'">{{ 'communication.failed' | translate }}</i>                    

                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'COMPLETED'">{{ 'communication.completed' | translate }}</i>
                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'PENDING'">{{ 'communication.pending' | translate }}</i>
                    <i class="text-sm text-faded" *ngIf="item.currentStatus == 'FAILED'">{{ 'communication.failed' | translate }}</i>                    
                    
                  </div>
                </div>               
            </div>
          </div>
        </div>
  
        <div class="modal-footer align-items-center py-2">
          <!-- <div class="message-send-group btn-group dropup"> -->
            <button *ngIf="!historyMode" type="button" class="btn btn-main px-3" data-dismiss="modal" data-target="#modal-message" (click)="sendNow()">{{ 'communication.sendNow' | translate }}</button>
            &nbsp;
            <!-- <button *ngIf="!historyMode" type="button" class="btn btn-main dropdown-toggle dropdown-toggle-split send-later" data-bs-toggle="dropdown" aria-expanded="false">
              <span class="text-sm">{{ 'communication.sendLater' | translate }}</span>
              <i class="ihost-icon-clock"></i>
            </button> -->
            <div *ngIf="!historyMode" class="dropdown-menu dropdown-menu-right p-3">
              <h3 class="mb-3">SCHEDULED SEND</h3>
              <input type="date" class="ihost-control message-scheduled-date w-100 mb-2">
              <input type="time" class="ihost-control message-scheduled-time w-100 mb-2">
             
              <button class="btn btn-main btn-sm w-100" data-dismiss="modal" data-target="#modal-message">{{ 'communication.sendLater' | translate }}</button>
            </div>
          <!-- </div> -->
          <div class="history-btn-group" *ngIf="historyMode">
            <a class="btn text-link btn-sec-alt" (click)="getHistory()">{{ 'communication.refreshList' | translate }}</a>
          </div>
        </div>
  
      </div>
    </div>
  </div>